import Axios from 'axios'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { selectToken,selectTwentySixMonthId } from '../../../../store/selectors'
import { Link } from 'react-router-dom'
function TwentySDetail(props) {
    const [twentySDetail,setTwentySDetail]=useState([])
    useEffect(async() => {
        await Axios.get(`https://tmstechnic.pythonanywhere.com/loko/twentysixmonth/detail/${props.twentySixMonthId}`,{
            headers: {
                Authorization: `Bearer ${props.token}`
            }
        })
        .then(res => setTwentySDetail(res.data))
    }, [])
    return (
        <div>
            <div className="page-name-part">
                <Link to="/twenty-sixmonth" className="link">
                    <i className="fa fa-arrow-circle-o-left fa-2x"/>
                </Link>
                <h2>
                    {twentySDetail.TrainName} - Aylık Bakım Detay
                </h2>
            </div>

            <div className="back-body">
                <div className="back-body-header">
                    <div className="w-75 link">
                        {twentySDetail.TrainName} - Detay
                    </div>
                </div>
                <div className="padding-div-back">
                    <div className="p-3">
                        <div className="row mb-2">
                            <div className="col">
                                <b>Aylık Bakım Tarihi : </b>{twentySDetail.LastMaintenance}
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col">
                                <b>Sonra ki Bakım Tarihi :</b>  {twentySDetail.NextMaintenance}
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col">
                                <b>Durumu :</b> {twentySDetail.Status}
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-3">
                                <b>Bakımda Ölçülen Teker Çapları :</b>
                            </div>
                            <div className="col-6">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr style={{ backgroundColor: "#ec7424", color: "white" }}>
                                            <th scope="col">AKS</th>
                                            <th scope="col">Sol Teker</th>
                                            <th scope="col">Sağ Teker</th>
                                        </tr>
                                    </thead>
                                    <tbody className="tb">
                                        <tr>
                                            <th scope="row">1</th>
                                            <td>{twentySDetail.FirstAKSLeft}</td>
                                            <td>{twentySDetail.FirstAKSRight}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">2</th>
                                            <td>{twentySDetail.SecondAKSLeft}</td>
                                            <td>{twentySDetail.SecondAKSRight}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">3</th>
                                            <td>{twentySDetail.ThirdAKSLeft}</td>
                                            <td>{twentySDetail.ThirdAKSRight}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">4</th>
                                            <td>{twentySDetail.FourthAKSLeft}</td>
                                            <td>{twentySDetail.FourthAKSRight}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">5</th>
                                            <td>{twentySDetail.FifthAKSLeft}</td>
                                            <td>{twentySDetail.FifthAKSRight}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">6</th>
                                            <td>{twentySDetail.SixthAKSLeft}</td>
                                            <td>{twentySDetail.SixthAKSRight}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col">
                                <b>Doppler Kalibrasyonu :</b>  {twentySDetail.Doppler}
                            </div>
                        </div>

                        <div className="row mb-2">
                            <div className="col-3 pr-0">
                                <b> Açıklama :</b>
                            </div>
                            <div className="col-9" style={{
                                wordWrap: "break-word"
                            }}>
                                <p>
                                {twentySDetail.Content}
                                </p>
                                <img src={twentySDetail.Image} alt={twentySDetail.Image} style={{ width: "50%", objectFit: "scale-down" }} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = createStructuredSelector({
    twentySixMonthId:selectTwentySixMonthId(),
    token:selectToken(),
})

export default connect(mapStateToProps)(TwentySDetail)